import { render, staticRenderFns } from "./aprobados.vue?vue&type=template&id=01184e35&scoped=true"
import script from "./aprobados.vue?vue&type=script&lang=js"
export * from "./aprobados.vue?vue&type=script&lang=js"
import style0 from "./aprobados.vue?vue&type=style&index=0&id=01184e35&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01184e35",
  null
  
)

export default component.exports